// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FZ-z","hovered":"GZ-z","hoverImage":"HZ-z","mainImage":"IZ-z","imageNoBackground":"JZ-z","fullSizeImage":"KZ-z"};